import { render, staticRenderFns } from "./CampaignDetails.vue?vue&type=template&id=11744709&"
import script from "./CampaignDetails.vue?vue&type=script&lang=js&"
export * from "./CampaignDetails.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDetails.vue?vue&type=style&index=0&id=11744709&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11744709')) {
      api.createRecord('11744709', component.options)
    } else {
      api.reload('11744709', component.options)
    }
    module.hot.accept("./CampaignDetails.vue?vue&type=template&id=11744709&", function () {
      api.rerender('11744709', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/campaign/EditCampaign/CampaignDetails.vue"
export default component.exports